export default {
    move_to_another_account_title: "Mover a otra cuenta",
    move_to_another_account_account_from: "Cuenta Origen",
    move_to_another_account_account_to: "Cuenta Destino",
    move_to_another_account_keyfobs: "LLaveros",
    move_to_another_account_input: "# Identificadores",
    move_to_another_account_identifier: "Identificador",
    move_to_another_account_account: "Cuenta",
    move_to_another_account_driver: "Conductor",
    move_to_another_account_model: "Modelo",
    move_to_another_account_change: "Mover",
    move_to_another_account_no_devices_added: "No se han añadido llaveros",
    move_to_another_account_device_is_already_added: "El dispositivo ya está añadido",
    move_to_another_account_device_has_not_been_found: "No se ha encontrado el dispositivo",
    move_to_another_account_this_feature_is_not_available: "Esta función no está disponible",
    move_to_another_account_single_success_message: "se ha movido el llavero",
    move_to_another_account_multiple_success_message: "Se han movido los llaveros",
    move_to_another_account_error_message: "No se pueden mover los llaveros debido a un error",
    move_to_another_account_select_to_account: "Seleccione la cuenta de destino primero",
    move_to_another_account_restriction_to_move: "No se pueden mover llaveros a cuentas que no están activas",
}